module.exports = __webpack_public_path__ + "img/icon-logo2.11eb642b.svg";